import React from "react";

import DefaultEnrollmentCard from "./EnrollmentCards/DefaultEnrollmentCard";
import LawEnrollmentCard from "./EnrollmentCards/LawEnrollmentCard";
import ConcurrentEnrollmentCard from "./EnrollmentCards/ConcurrentEnrollmentCard";

import { fetchEnrollmentResources } from "data/slices/users/enrollmentResources";
import MBAEnrollmentCard from "./EnrollmentCards/MBAEnrollmentCard";

import { ErrorBoundary } from "components/ui/ErrorBoundary";

import { dispatchUserSlice } from "components/hooks/dispatchUserSlice";
import { useUser } from "components/hooks/useUser";

function groupPresentationsByDesign(presentations) {
  return presentations.reduce(
    (acc, current) => {
      acc[current.design] = acc[current.design]
        ? [...acc[current.design], current]
        : [current];
      return acc;
    },
    {
      haasEveningWeekendMba: [],
      haasFullTimeMba: [],
      haasExecMba: [],
    }
  );
}

// https://wikihub.berkeley.edu/display/SIS/CalCentral+Class+Enrollment+Card
export function EnrollmentCards() {
  return (
    <ErrorBoundary title="Class Enrollment">
      <EnrollmentCardsUI />
    </ErrorBoundary>
  );
}

export function EnrollmentCardsUI() {
  dispatchUserSlice(fetchEnrollmentResources);

  const enrollmentResources = useUser((user) => user.enrollmentResources);

  const { presentations = [], termInstructions = [] } =
    enrollmentResources || {};

  const presentationsByDesign = groupPresentationsByDesign(presentations);

  const mbaPresentations = [
    ...presentationsByDesign.haasEveningWeekendMba,
    ...presentationsByDesign.haasFullTimeMba,
    ...presentationsByDesign.haasExecMba,
  ];

  return (
    <>
      {presentationsByDesign.default && (
        <DefaultEnrollmentCard
          presentations={presentationsByDesign.default}
          termInstructions={termInstructions}
        />
      )}

      {presentationsByDesign.law && (
        <LawEnrollmentCard
          presentations={presentationsByDesign.law}
          termInstructions={termInstructions}
        />
      )}

      {presentationsByDesign.concurrent && (
        <ConcurrentEnrollmentCard
          presentations={presentationsByDesign.concurrent}
          termInstructions={termInstructions}
        />
      )}

      {mbaPresentations.length > 0 && (
        <MBAEnrollmentCard
          presentations={mbaPresentations}
          termInstructions={termInstructions}
        />
      )}
    </>
  );
}

EnrollmentCards.displayName = "EnrollmentCards";
